import React from "react";
import clsx from "clsx";

import CheckDoneIcon from "../../../img/check_done.svg";

const ToggleSwitch = ({ checked, onChange, disabled = false }) => {
  return (
    <div
      onClick={onChange}
      disabled={disabled}
      className={clsx("toggle-switch", {
        "toggle-switch--on": checked,
        "toggle-switch--off": !checked,
        "toggle-switch--disabled": disabled,
      })}
      aria-pressed={checked}
    >
      <span className="toggle-switch__handle">
        <img src={CheckDoneIcon} alt="Check" />
      </span>
    </div>
  );
};

export default ToggleSwitch;
